import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';
import { endpoints } from 'src/utils/axios';
import { UserToLoginType } from 'src/types/login';

export class LoginRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async login(
    body: UserToLoginType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const { email, password } = body;
    const encryptedData = btoa(`${email}:${password}`);
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.login,
      body,
      headers: {
        Authorization: `Basic ${encryptedData}`,
      },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getData(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.me,
      body: {},
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
